import { render, staticRenderFns } from "./cv-data-table-action.vue?vue&type=template&id=8b5e25b6&"
import script from "./cv-data-table-action.vue?vue&type=script&lang=js&"
export * from "./cv-data-table-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports